import React from "react";
import clsx from "clsx";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";

import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import BookIcon from "@material-ui/icons/Book";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CreateIcon from "@material-ui/icons/Create";
import FeedbackIcon from "@material-ui/icons/Feedback";
import MenuIcon from "@material-ui/icons/Menu";

import { Link } from "react-router-dom";
export default function BlogMenubar({ user }) {
  let menuItems = [
    {
      title: "My blog",
      link: `/blog/user/${user.user_id}`,
      icon: <BookIcon />,
    },
    {
      title: "Create new blog",
      link: "/blog/creator/new",
      icon: <CreateIcon />,
    },
    {
      title: "How to write",
      link: "/blog/how-to-write",
      icon: <AssignmentIcon />,
    },
    { title: "Media", link: "", icon: <PhotoLibraryIcon /> },
    { title: "Feedback", link: "", icon: <FeedbackIcon /> },
  ];
  const classes = {
    list: {
      width: 250,
    },
    fullList: {
      width: "auto",
    },
  };
  const [state, setState] = React.useState({
    open: false,
    anchor: "top",
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer("open", false)}
      onKeyDown={toggleDrawer("open", false)}
    >
      <List className="d-flex mt-5" style={{ flexDirection: "column" }}>
        {menuItems.map((item, index) => (
          <ListItem
            dense
            button
            key={item.title}
            component={Link}
            to={item.link}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        ))}
      </List>
      {/* <Divider /> */}
    </div>
  );

  return (
    <div className="text-center">
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="end"
        onClick={toggleDrawer("open", true)}
      >
        <MenuIcon className="hvr-pulse" />
      </IconButton>
      <SwipeableDrawer
        style={{ zIndex: 800 }}
        anchor={state.anchor}
        open={state.open}
        onClose={toggleDrawer("open", false)}
        onOpen={toggleDrawer("open", true)}
      >
        {list(state.anchor)}
      </SwipeableDrawer>
    </div>
  );
}
